import React from 'react';





import {

  Grid,

  Divider,
} from '@material-ui/core';



import Fluidigmall from '../../../../components/Pcat/Fluidigmall/Fluidigmall';





export default function Fluidigmfetch() {


  return (
    <div>

      {/* <Sales data = {fluid}/> */}

      <Fluidigmall />




      <Grid item xs={12}>
        <Divider />
      </Grid>





    </div>

  );
}

